import { render, staticRenderFns } from "./_helpHis.vue?vue&type=template&id=a20f779e&scoped=true&"
import script from "./_helpHis.vue?vue&type=script&lang=js&"
export * from "./_helpHis.vue?vue&type=script&lang=js&"
import style0 from "./_helpHis.vue?vue&type=style&index=0&id=a20f779e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20f779e",
  null
  
)

export default component.exports